import { SVGProps } from 'react'

export const NavTwitterIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.4538 5H18.8288L13.6402 10.9303L19.7442 19H14.9648L11.2214 14.1057L6.93812 19H4.56171L10.1114 12.6569L4.25586 5H9.15658L12.5403 9.47354L16.4538 5ZM15.6203 17.5785H16.9363L8.4415 6.34687H7.0293L15.6203 17.5785Z"
        fill="white"
      />
    </svg>
  )
}
